// src/reducers/userReducer.js

import { types } from '../types/types';

const initialState = {
    editingUser: {
        code: '',
        id: 0,
        name: '',
        password: '',
        permission: '',
        realmFk: '',
        status: true,
        userName: '',
    },
    availableUsers : [],
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingUserInfo:
            return {
                ...state,
                editingUser: action.payload,
            };

        case types.clearUserInfo:
            return {
                ...state,
                editingUser: initialState.editingUser,
            };

            case types.setAvailableUsers:
            return {
                ...state,
                availableUsers: action.payload
            };


        default:
            return state;
    }
};